import React, { useEffect, useState } from "react";
import Footer from "../widgets/Footer";
import Header from "../widgets/Header";
import { useNavigate } from "react-router-dom";
import { Emailpattern } from "../patterns/Pattern";
import { toast } from "react-toastify";
import {
  useSetUserLoginMutation,
  useUpdateFirstPasswordMutation,
} from "../../redux/user";
import { useAuth } from "../../AuthContext";
import * as EmailValidator from "email-validator";
import socket from "../constant/socket";
import { PasswordValid } from "../validations/PasswordValid";

function Login() {
  const navigate = useNavigate();
  const { login, authenticated } = useAuth();
  const [setUserLogin] = useSetUserLoginMutation();
  const [updateFirstPassword] = useUpdateFirstPasswordMutation();
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [disable, setDisable] = useState(false);
  const [passFieldShow, setPassFieldShow] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState({
    eye: "bi-eye-slash",
    type: "password",
  });

  const [passwordfield, setPasswordfield] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordfieldErr, setPasswordfieldErr] = useState({
    password: "",
    confirmPassword: "",
  });

  const [showConfirmPassword, setShowConfirmPassword] = useState({
    eye: "bi-eye-slash",
    type: "password",
  });

  useEffect(() => {
    if (authenticated) {
      navigate("/dashboard");
    }
    document.title = "Login";
  }, [authenticated]);

  const shownewPassword = () => {
    if (showNewPassword.type === "password") {
      setShowNewPassword({ eye: "bi-eye", type: "text" });
    } else {
      setShowNewPassword({ eye: "bi-eye-slash", type: "password" });
    }
  };

  const showconfirmPassword = () => {
    if (showConfirmPassword.type === "password") {
      setShowConfirmPassword({ eye: "bi-eye", type: "text" });
    } else {
      setShowConfirmPassword({ eye: "bi-eye-slash", type: "password" });
    }
  };

  const handlepassword = (e) => {
    const { name, value } = e.target;
    setPasswordfield({ ...passwordfield, [name]: value });
    let cPassword = passwordfield.confirmPassword;
    let nPassword = passwordfield.password;
    let checkLogin = PasswordValid(name, value, nPassword, cPassword);
    console.log(checkLogin,"checkLogin")
    if (checkLogin?.length > 0) {
      const newErrors = { ...passwordfieldErr };
      checkLogin.forEach(({ name, error }) => {
        newErrors[name] = error;
      });

      setPasswordfieldErr(newErrors);
    } else {
      setPasswordfieldErr({
        ...passwordfieldErr,
        [checkLogin.name]: checkLogin.error,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
      if (value === "") {
        setEmailErr("This field is required.");
      }
      if (!Emailpattern.test(value)) {
        setEmailErr("Please enter valid email.");
      }
      if (!EmailValidator.validate(value)) {
        setEmailErr("Please enter valid email.");
      } else {
        setEmailErr("");
      }
    }
    if (name === "password") {
      setPassword(value);
      if (value === "") {
        setPasswordErr("This field is required");
      } else {
        setPasswordErr("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let sendData;

    if (email === "") {
      setEmailErr("Please enter email.");
      return;
    }
    if (!EmailValidator.validate(email)) {
      setEmailErr("Please enter valid email.");
      return;
    }
    sendData = { email, password: password };

    if (password === "") {
      setPasswordErr("Please enter password.");
      return;
    }
    setDisable(true);
    setUserLogin(sendData).then((result) => {
      if (result.data.status) {
        if (result.data.data.is_first_change === "0") {
          setPassFieldShow(true);
          setId(result.data.data.id);
          setDisable(false);
        } else {
          socket.emit(
            "user-connect",
            result.data.data.id
          );
          toast.dismiss();
          toast.success(result.data.message);
          setTimeout(() => {
            login();
            localStorage.setItem("token", result.data.token);
            window.location.href = "/dashboard";
          }, 3000);
        }
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(result.data.message);
      }
    });
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    let cPassword = passwordfield.confirmPassword;
    let nPassword = passwordfield.password;
    for (let key in passwordfield) {
      let checkLogin = PasswordValid(
        key,
        passwordfield[key],
        nPassword,
        cPassword
      );
      if (checkLogin?.length > 0) {
        const newErrors = { ...passwordfieldErr };
        checkLogin.forEach(({ name, error }) => {
          newErrors[name] = error;
        });

        setPasswordfieldErr(newErrors);
        if (checkLogin[0].error !== "" || checkLogin[1].error !== "") {
          return false;
        }
      } else {
        setPasswordfieldErr({
          ...passwordfieldErr,
          [checkLogin.name]: checkLogin.error,
        });
        if (checkLogin.error !== "") {
          return false;
        }
      }
    }
    setDisable(true);
    const sendData = {
      new_password: passwordfield.password,
      confirm_password: passwordfield.confirmPassword,
      id: id,
    };
    updateFirstPassword(sendData).then((result) => {
      if (result.data.status) {
        toast.dismiss();
        toast.success(result.data.message);
        setTimeout(() => {
          setDisable(false);
          setPassFieldShow(false);
        }, 3000);
      } else {
        setDisable(false);
        toast.dismiss();
        toast.error(result.data.message);
      }
    });
  };

  return (
    <>
      <Header />
      <section className="loginsection">
        <div className="container  ">
          <div className="login_box ">
            <div className="row m-0  ">
              <div className="col-md-5   d-flex login_left   justify-content-center  align-items-center">
                <div className=" text-center">
                  <h3 className="mb-4">Hello, Friends</h3>
                  <p className="mb-4">
                    Fill up personal information and start journey with us.
                  </p>
                </div>
              </div>
              <div className="col-md-7 pt-4 pb-4">
                <div className="p-md-4 p-2">
                  <h3 className="mb-4 text-center">
                    {passFieldShow ? "Change Password" : "Sign in to Account"}
                  </h3>

                  {!passFieldShow && (
                    <form className="" onSubmit={handleSubmit}>
                      <div className="form-group mb-3">
                        <label>Email </label>

                        <input
                          className="form-control"
                          autocomplete="off"
                          type="text"
                          name="email"
                          placeholder="Enter Email"
                          value={email}
                          onChange={handleChange}
                          maxLength={65}
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        />

                        <span className="text-danger">{emailErr}</span>
                      </div>
                      <div className="form-group mb-3">
                        <label>Password</label>
                        <div className="eye_pass position-relative">
                          <input
                            className="form-control"
                            autocomplete="off"
                            type={showNewPassword.type}
                            name="password"
                            id="password"
                            placeholder="Enter Password"
                            value={password}
                            onChange={handleChange}
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            maxLength={16}
                          />
                          <span
                            className="password__show position-absolute eye1"
                            onClick={shownewPassword}
                          >
                            <i className={`bi ${showNewPassword.eye}`}></i>
                          </span>
                        </div>
                        <span className="text-danger">{passwordErr}</span>
                      </div>
                      <div className="form-group mb-3">
                        <div className="form-group mb-3 log-btn mx-auto">
                          <button
                            className="btn w100 btn2"
                            type="submit"
                            disabled={disable}
                          >
                            Login
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                  {passFieldShow && (
                    <form onSubmit={handlePasswordChange}>
                      <div className="form-group mb-3">
                        <label>Password</label>
                        <div className="eye_pass position-relative">
                          <input
                            className="form-control"
                            autocomplete="off"
                            type={showNewPassword.type}
                            name="password"
                            id="password"
                            placeholder="Enter Password"
                            value={passwordfield.password}
                            onChange={handlepassword}
                            maxLength={16}
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onKeyPress={(event) => {
                              if (event.key === " ") {
                                event.preventDefault();
                              }
                            }}
                            onInput={(event) => {
                              // Remove spaces if user uses mobile/touch input
                              event.target.value = event.target.value.replace(
                                /\s/g,
                                ""
                              );
                            }}
                          />
                          <span
                            className="password__show position-absolute eye1"
                            onClick={shownewPassword}
                          >
                            <i className={`bi ${showNewPassword.eye}`}></i>
                          </span>
                          <span className="text-danger">
                            {passwordfieldErr.password}
                          </span>
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label>Confirm Password</label>
                        <div className="eye_pass position-relative">
                          <input
                            className="form-control"
                            autocomplete="off"
                            type={showConfirmPassword.type}
                            name="confirmPassword"
                            id="confirmPassword"
                            placeholder="Enter Confirm  Password"
                            value={passwordfield.confirmPassword}
                            onChange={handlepassword}
                            maxLength={16}
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onKeyPress={(event) => {
                              if (event.key === " ") {
                                event.preventDefault();
                              }
                            }}
                            onInput={(event) => {
                              // Remove spaces if user uses mobile/touch input
                              event.target.value = event.target.value.replace(
                                /\s/g,
                                ""
                              );
                            }}
                          />
                          <span
                            className="password__show position-absolute eye1"
                            onClick={showconfirmPassword}
                          >
                            <i className={`bi ${showConfirmPassword.eye}`}></i>
                          </span>
                          <span className="text-danger">
                            {passwordfieldErr.confirmPassword}
                          </span>
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <div className="form-group mb-3 log-btn mx-auto">
                          <button
                            className="btn btn2 w100"
                            type="submit"
                            disabled={disable}
                          >
                            Change Password
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Login;
